import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col d-flex" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "mx-auto" }, "Terms of use")
  ])
], -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "row mt-2" }
const _hoisted_7 = { class: "col d-flex" }
const _hoisted_8 = { class: "form-check mx-auto" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "checkboxAcceptTerms"
}, " I confirm that I accept the privacy policy and the above terms of use. ", -1)
const _hoisted_10 = { class: "row mt-2" }
const _hoisted_11 = { class: "col d-flex" }
const _hoisted_12 = ["disabled"]

import { onBeforeMount, ref } from 'vue';

// -- Own Vue components -- //
import GlassModal from '@/components/modals/GlassModal.vue';

// -- Own functions -- //
import { getTerms, APP_SETTINGS, SERVER_DATA } from '@/aux/app_configuration';

/**
 * Create declarations within template
 */
// -- Props -- //
interface Props {
  termsVersion: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TermsAgreement',
  props: {
    termsVersion: null
  },
  emits: ['termsAccepted'],
  setup(__props: any, { emit }) {

const props = __props as {
  termsVersion: number;
};

/**
 * Imports
 */
// -- Vue methods -- //


// -- Refs -- //
const terms = ref<string>();
const acceptTerms = ref<boolean>(false);

// -- Emit definitions -- //


/**
 * Load terms from server
 */
onBeforeMount(() => {
  getTerms().then(
    (data) =>
      (terms.value = data.replace(
        '$PRIVACY_POLICY',
        `${SERVER_DATA['PUBLIC_FOLDER']}/privacy_policy/${APP_SETTINGS(
          'PRIVACY_POLICY'
        )}`
      ))
  );
});

/**
 * Accept terms handler
 */
const acceptTermsHandler = (): void => {
  if (acceptTerms.value) {
    localStorage.setItem(
      'TroubleReportToolAcceptedTermsVersion',
      props.termsVersion.toString()
    );
    emit('termsAccepted');
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GlassModal, { closeable: false }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", { innerHTML: terms.value }, null, 8, _hoisted_5)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((acceptTerms).value = $event)),
                id: "checkboxAcceptTerms"
              }, null, 512), [
                [_vModelCheckbox, acceptTerms.value]
              ]),
              _hoisted_9
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary mx-auto",
              disabled: !acceptTerms.value,
              onClick: acceptTermsHandler
            }, " Confirm ", 8, _hoisted_12)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})